<template>
  <auth-layout pageClass="forgot-password-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="label-control" @submit.prevent="handleSubmit(sendResetEmail)">
            <card>
              <div class="card-header" slot="header">
                <h3
                  class="card-title text-center"
                  style="color: #d9d9d9; font-weight: bold"
                >
                  Forgot Password
                </h3>
              </div>
              <div v-if="!emailSent">
                <p class="text-center" style="color: #d9d9d9; font-size: 14px;">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
                <div class="login-fields-container">
                  <ValidationProvider
                    name="Email"
                    rules="required|email"
                    tag="div"
                    class="mb-3"
                    v-slot="{ errors }"
                  >
                    <label>
                      Email Address
                      <el-input
                        v-model="email"
                        type="email"
                        class="small-select login-inputs-background"
                      ></el-input>
                    </label>
                    <div
                      v-if="errors.length"
                      class="text-danger"
                      style="font-size: 0.875em"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div v-else>
                <div class="text-center" style="color: #d9d9d9;">
                  <i class="fa fa-check-circle fa-3x mb-3" style="color: #28a745;"></i>
                  <p>Password reset link has been sent to your email address.</p>
                  <p>Please check your inbox and follow the instructions.</p>
                </div>
              </div>
              <div class="text-center" v-if="!emailSent">
                <button
                  type="submit"
                  class="login-btn btn-fill btn-info btn-wd"
                  :disabled="loading"
                >
                  {{ loading ? 'Sending...' : 'Send Reset Link' }}
                </button>
                <br />
                <div class="mt-3">
                  <router-link to="/login" class="back-to-login">
                    Back to Login
                  </router-link>
                </div>
              </div>
              <div class="text-center" v-else>
                <router-link to="/login" class="login-btn btn-fill btn-info btn-wd">
                  Back to Login
                </router-link>
              </div>
            </card>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "./AuthLayout.vue";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import commonHandler from "src/serviceHandlers/commonHandler";

const apiService = new commonHandler();

extend("email", email);
extend("required", required);

export default {
  components: {
    AuthLayout,
  },
  data() {
    return {
      email: "",
      emailSent: false,
      loading: false,
    };
  },
  methods: {
    async sendResetEmail() {
      this.loading = true;
      this.$spinner.show();

      try {
        const response = await apiService.forgotPassword({ email: this.email });

        if (response.success) {
          this.emailSent = true;
          this.$notifySuccess("Password reset link sent successfully!");
        } else {
          this.$notifyError(response.message || "Failed to send reset email. Please try again.");
        }
      } catch (error) {
        this.$notifyError("An error occurred. Please try again later.");
      } finally {
        this.loading = false;
        this.$spinner.hide();
      }
    },
  },
};
</script>

<style>
.card-header {
  background: none !important;
  height: 60px;
  font-family: "Playfair Display", serif;
}
</style>

<style scoped>
.card-title {
  font-family: "Playfair Display", serif;
}

.login-btn {
  background-color: rgba(37, 55, 65, 0.8);
  padding-bottom: 7px;
  padding-top: 5px;
  border-radius: 12px;
  border: 1px solid #253741;
  color: #d9d9d9 !important;
  font-family: "Nimbus Sans Light", sans-serif;
  font-weight: bold;
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
}

.login-btn:hover {
  background-color: rgba(37, 55, 65, 1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

label {
  color: #d9d9d9 !important;
  font-family: "Nimbus Sans Light", sans-serif;
  font-size: 14px !important;
  letter-spacing: 0.05rem !important;
}

.back-to-login {
  color: #d9d9d9;
  text-decoration: underline;
  font-size: 14px;
  transition: color 0.3s ease;
}

.back-to-login:hover {
  color: #fff;
}

.login-fields-container {
  margin-right: 20px;
}

.login-fields-container .small-select {
  width: 305px !important;
}

/* Mobile-specific adjustments */
@media (max-width: 576px) {
  .login-fields-container {
    padding: 0 8px;
    margin-right: 0;
  }

  .login-fields-container .small-select {
    width: 100% !important;
  }

  .card {
    margin: 0 !important;
  }
}
</style>